/**
 * Zero-state line art: one drawing per trip section, plus one per idea /
 * event category. Every asset inherits `currentColor` and carries no intrinsic
 * size, so the same drawing serves as a small tile chip and as a page-sized
 * illustration — the surface decides colour and size.
 *
 * `emptyStateArt` is the name → component lookup the shared `EmptyState`
 * component takes as its `art` prop; import the components directly when a
 * caller needs one specific drawing.
 */
import AccommodationsArt from './accommodations.svg?react'
import EventsArt from './events.svg?react'
import ExpensesArt from './expenses.svg?react'
import FilesArt from './files.svg?react'
import FlightsArt from './flights.svg?react'
import FoodAndDrinkArt from './food-and-drink.svg?react'
import IdeasArt from './ideas.svg?react'
import ItineraryArt from './itinerary.svg?react'
import NatureArt from './nature.svg?react'
import OtherArt from './other.svg?react'
import SeeAndDoArt from './see-and-do.svg?react'
import ShoppingArt from './shopping.svg?react'

export const emptyStateArt = {
	accommodations: AccommodationsArt,
	events: EventsArt,
	expenses: ExpensesArt,
	files: FilesArt,
	flights: FlightsArt,
	foodAndDrink: FoodAndDrinkArt,
	ideas: IdeasArt,
	itinerary: ItineraryArt,
	nature: NatureArt,
	other: OtherArt,
	seeAndDo: SeeAndDoArt,
	shopping: ShoppingArt,
} as const

/** Key of a drawing in the zero-state art set. */
export type EmptyStateArt = keyof typeof emptyStateArt

export {
	AccommodationsArt,
	EventsArt,
	ExpensesArt,
	FilesArt,
	FlightsArt,
	FoodAndDrinkArt,
	IdeasArt,
	ItineraryArt,
	NatureArt,
	OtherArt,
	SeeAndDoArt,
	ShoppingArt,
}
